<nav class="head-nav">
  <h2 *ngIf="lang == 'en'">{{restaurantProfile?.title_EN}}</h2>
  <h2 *ngIf="lang == 'ar'">{{restaurantProfile?.title_AR}}</h2>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
    </li>
    <li class="breadcrumb-item" *ngIf="!isMainProfile">
      <a [routerLink]='["/admin/restaurants"]'>{{ "restaurant.Branches" | translate }}</a>
    </li>
    <li class="breadcrumb-item" *ngIf="lang == 'en'">{{restaurantProfile?.title_EN}}
    </li>
    <li class="breadcrumb-item" *ngIf="lang == 'ar'">{{restaurantProfile?.title_AR}}
    </li>

  </ol>
</nav>

<div *ngIf='dataLoading' class="dataLoading py-5">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div class="form-page">
  <div class="form-content form-content-full">
    <ng-container *ngIf='!dataLoading && restaurantProfile'>

      <div class="card mb-3 py-2">
        <div class="card-head">
          <div class="title">{{'restaurant.Enable Clock-in/out' | translate}}</div>

          <div class="d-flex align-items-center">
            <div class="mr-3" *ngIf="attandanceFeatureLoader">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
            <div>
              <mat-slide-toggle [(ngModel)]="restaurantProfile.attandanceFeature"
                [disabled]="attandanceFeatureLoader"
                (ngModelChange)="changeAttendance()"></mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>

      <app-publish-restaurant *ngIf="!restaurantProfile.isPublish" [restaurantProfile]="restaurantProfile" [restaurantId]="restaurantId"></app-publish-restaurant>
      <app-head-details [restaurantProfile]="restaurantProfile"></app-head-details>

      <ng-container *ngIf="!isMainProfile">

        <ul class="nav nav-tabs" id="tabs" [hidden]="dataLoading" (mousedown)="startDragging($event, false)"
          (mouseup)="stopDragging($event, false)" (mouseleave)="stopDragging($event, false)"
          (mousemove)="moveEvent($event)">
          <li class="nav-item" *ngFor="let item of tabs; index as index">
            <a class="nav-link font-16 fontMedium" [class.active]="activeIndex == index"
            (click)="navigateToSection($event, index)">{{item.name}}</a>
          </li>
        </ul>

      </ng-container>

      <app-numbers *ngIf="!isMainProfile" [restaurantProfile]="restaurantProfile"></app-numbers>

      <app-basic-info id="tab-0" [restaurantProfile]="restaurantProfile"></app-basic-info>
      <ng-container *ngIf="!isMainProfile && restaurantProfile.canShowShortCut">
        <app-navigation *ngIf="restaurantProfile.canViewConfigSection"></app-navigation>
      </ng-container>
      <div id="tab-1" class="placeholder">
        <app-gallery [restaurantId]="restaurantId" *inView></app-gallery>
      </div>
      <div id="tab-2" class="placeholder">
        <app-amenities [restaurantId]="restaurantId" *inView id="tab-2"></app-amenities>
      </div>

      <ng-container *ngIf="!isMainProfile">
        <!-- <div id="tab-5" class="placeholder">
          <app-guest-reviews [restaurantId]="restaurantId" *inView id="tab-5"></app-guest-reviews>
        </div> -->
        <!-- <div id="tab-5" class="placeholder">
          <app-guest-reviews [restaurantId]="restaurantId" *inView id="tab-5"></app-guest-reviews>
        </div>
        <div id="tab-6" class="placeholder">
          <app-events [restaurantId]="restaurantId" *inView id="tab-6"></app-events>
        </div>
        <div id="tab-7" class="placeholder">
          <app-guest-announcement [restaurantId]="restaurantId" *inView id="tab-7"></app-guest-announcement>
        </div> -->
        <div id="tab-3" class="placeholder">
          <app-payment-methods [restaurantId]="restaurantId" *inView id="tab-6"></app-payment-methods>
        </div>
        <div id="tab-4" class="placeholder">
          <app-cancellation *inView id="tab-6"
          [canViewCancellationPolicy]="restaurantProfile.canViewCancellationPolicy"
          [canAddCancellationPolicy]="restaurantProfile.canAddCancellationPolicy"
          [canEditCancellationPolicy]="restaurantProfile.canEditCancellationPolicy"
          [canDeleteCancellationPolicy]="restaurantProfile.canDeleteCancellationPolicy"></app-cancellation>
        </div>
        <div id="tab-5" class="placeholder">
          <app-reservation *inView id="tab-7"></app-reservation>
        </div>
      </ng-container>

    </ng-container>
  </div>
</div>
